import { Feature, isFeatureFlagEnabled } from 'core'

import useQueryRequestV2 from './useQueryRequestV2'

const useFeatureFlag = (feature: Feature) => {
  const { data } = useQueryRequestV2<boolean>({
    initialState: false,
    queryFn: () => isFeatureFlagEnabled(feature),
  })

  return data
}

export default useFeatureFlag
